import React from 'react';

/* eslint-disable max-len,no-tabs,camelcase */
const Eyes_7 = ({ eyeColours, skinColours }) => {
  const colour0 = '#573D39';
  const colour1 = '#F15743';
  const colour2 = '#FFFEF0';
  const colour3 = '#F6E7D0';
  const colour4 = eyeColours.shadow;
  const colour5 = '#DF5656';
  const colour6 = skinColours.shadow;

  return (
    <>
      <g>
        <g>
          <path
            fill={colour0}
            d="M492.2,383.2c0.8,3.6,2.5,13.3,7,15.6l-14.3-0.8C484.2,386.8,491.4,379.7,492.2,383.2z"
          />
          <g>
            <path
              fill={colour1}
              opacity={0.5}
              d="M436.3,396.4c-2.9-0.3-15.3-4.7-15.7-5.7c-0.3-1,14-15.8,14-15.8L436.3,396.4z"
            />
            <path
              fill={colour0}
              d="M488.1,389.7c3.5-16.4-6.6-33.4-21.5-36.6c-14.9-3.2-29.7,7.5-33.2,23.9c-3.5,16.4,5.7,32.2,20.6,35.4
				C468.8,415.5,484.6,406.1,488.1,389.7z"
            />
            <path
              fill={colour2}
              d="M485.4,385.7c3.1-14.5-5.4-28.7-19-31.6c-13.6-2.9-27.1,6.5-30.2,21c-3.1,14.5,5.9,26.2,19.5,29.1
				C469.2,407.1,482.2,400.2,485.4,385.7z"
            />
            <path
              fill={colour3}
              d="M457.7,401.1c-13.6-2.9-22.5-15.2-19.4-29.8c0.5-2.3,1.3-4.5,2.3-6.6c-2.1,3-3.7,6.5-4.5,10.4
				c-3.1,14.5,5.8,26.9,19.4,29.8c11.5,2.5,22.8-2.7,27.8-13.2C477.6,399.7,467.8,403.3,457.7,401.1z"
            />
            <path
              fill={colour4}
              d="M470.5,385.7c1.4-6.3-2.4-12.5-8.3-13.7c-5.9-1.3-11.9,2.8-13.2,9.1c-1.4,6.3,2.4,12.5,8.3,13.7
				C463.2,396.1,469.2,392,470.5,385.7z"
            />
            <path
              fill={colour2}
              d="M467,396.4c2.2-0.9,3.3-3.1,2.6-4.7c-0.7-1.7-3.1-2.3-5.2-1.3c-2.2,0.9-3.3,3.1-2.6,4.7
				C462.5,396.7,464.8,397.3,467,396.4z"
            />
            <path
              fill={colour2}
              d="M469.3,386.9c0.4-0.9,0.1-1.9-0.6-2.2c-0.7-0.3-1.6,0.2-2,1.1c-0.4,0.9-0.1,1.9,0.6,2.2
				C468,388.4,468.9,387.9,469.3,386.9z"
            />
            <path
              fill={colour5}
              opacity={0.5}
              d="M494,391.3c-3.3-15.6-12.1-28.1-27.2-31.3c-13-2.8-30.5,1.9-36.3,13.7c0.7,2.6,1.7,3.5,2.3,4.3
				c10,1.1,46,9.6,53.9,15.4C488.8,393.4,493.6,392.3,494,391.3z"
            />
            <path
              fill={colour6}
              d="M428.2,376.9c18-2.2,44.4-4.1,64.4,10.7c0,0,1.1-30.1-24.3-35.5C438.8,345.7,428.2,376.9,428.2,376.9z"
            />
          </g>
          <path
            fill={colour0}
            d="M433.8,377.6c11.9-2.3,50.3-2.1,59.6,15.8c0,0,3.2-2.4,0-8c-7.9-14-52.5-15-60.8-12
			C431,374,432.7,377.9,433.8,377.6z"
          />
          <path
            fill={colour6}
            d="M487.9,399.1c0,0-3.6,16.8-25.4,17.2c-16.7,0.3-27.6-11.6-30.4-20.5c0,0,16.4,9.9,33.7,7.9
			C482.9,401.7,487.9,399.1,487.9,399.1z"
          />
          <path
            fill={colour0}
            d="M417.4,390.8c13.5,3,26,21.7,50.9,17.7c24.9-4,19-9.4,38.7-7.4c0,0-12.3-7.4-20.7-4.7
			c-8.4,2.7-21.6,9.2-34.4,6.3C441.8,400.4,429.2,389.8,417.4,390.8z"
          />
          <path
            fill={colour0}
            d="M504.5,380.2c0,0-8.5,7.2-14.9,6.4l2.5,2.5C492.1,389,500.7,387.9,504.5,380.2z"
          />
          <path
            fill={colour0}
            d="M499.2,375c0,0-6.5,9.2-12.9,10l3,1.7C489.3,386.7,497.5,383.3,499.2,375z"
          />
          <path
            fill={colour0}
            d="M494.3,371.5c0,0-5.8,9.7-12.1,11l3.2,1.5C485.4,384,493.2,380,494.3,371.5z"
          />
          <path
            fill={colour0}
            d="M487.7,368.3c0,0-5,10.1-11.2,12l3.3,1.2C479.8,381.5,487.3,376.8,487.7,368.3z"
          />
          <path
            fill={colour0}
            d="M480.1,365.5c0,0-1.3,9.1-6.2,10.5l3.2,1.2C477.1,377.3,482.3,373.3,480.1,365.5z"
          />
          <path
            fill={colour0}
            d="M417.4,390.8c10.2-2.6,7.5-17.2,15.7-17.4l14.3,2.3c0,0-13.2,0-16.2,3.6c-3,3.5-5.4,11.8-12.2,11.8
			C412.2,391.1,412.7,392,417.4,390.8z"
          />
        </g>
        <g>
          <path
            fill={colour0}
            d="M312.8,381.8c-1,3.5-3.1,13.2-7.7,15.3l14.3-0.1C320.7,385.8,313.8,378.3,312.8,381.8z"
          />
          <g>
            <path
              fill={colour1}
              opacity={0.5}
              d="M368,397.6c2.9-0.2,15.5-4,15.9-5c0.4-1-13.2-16.5-13.2-16.5L368,397.6z"
            />
            <path
              fill={colour0}
              d="M316.6,388.5c-2.7-16.5,8.2-33.1,23.2-35.6c15-2.5,29.3,8.9,32.1,25.4c2.7,16.5-7.2,31.9-22.2,34.4
				C334.7,415.2,319.4,405,316.6,388.5z"
            />
            <path
              fill={colour2}
              d="M319.6,384.6c-2.4-14.7,6.7-28.4,20.4-30.6c13.7-2.3,26.8,7.8,29.2,22.4c2.4,14.7-7.1,25.8-20.9,28.1
				C334.7,406.7,322,399.2,319.6,384.6z"
            />
            <path
              fill={colour3}
              d="M346.4,401.3c13.7-2.3,23.2-14.2,20.7-28.8c-0.4-2.4-1.1-4.6-2-6.7c2,3.1,3.4,6.7,4,10.6
				c2.4,14.7-7,26.6-20.7,28.8c-11.7,1.9-22.6-3.7-27.1-14.5C326.6,398.9,336.3,403,346.4,401.3z"
            />
            <path
              fill={colour4}
              d="M334.4,385.3c-1.1-6.4,3-12.3,9-13.3c6-1,11.7,3.4,12.8,9.8c1.1,6.4-3,12.3-9,13.3
				C341.2,396.1,335.4,391.7,334.4,385.3z"
            />
            <path
              fill={colour2}
              d="M349,388c1.2-2.1,3.4-3,5-2.1c1.6,0.9,1.9,3.3,0.8,5.4c-1.2,2.1-3.4,3-5,2.1C348.2,392.4,347.8,390,349,388z
				"
            />
            <path
              fill={colour2}
              d="M352.3,382.9c-0.3-0.9,0-1.9,0.7-2.2c0.7-0.3,1.6,0.3,2,1.2c0.3,0.9,0,1.9-0.7,2.2
				C353.5,384.4,352.7,383.8,352.3,382.9z"
            />
            <path
              fill={colour5}
              opacity={0.5}
              d="M310.7,389.8c4-15.5,13.4-27.5,28.6-30c13.1-2.2,30.4,3.3,35.6,15.4c-0.9,2.6-1.9,3.4-2.5,4.2
				c-10,0.6-46.4,7.4-54.6,12.9C315.7,392.1,311,390.8,310.7,389.8z"
            />
            <path
              fill={colour6}
              d="M377.1,378.5c-17.9-3-44.2-6.2-64.8,7.6c0,0,0.3-30.1,25.9-34.3C368,346.8,377.1,378.5,377.1,378.5z"
            />
          </g>
          <path
            fill={colour0}
            d="M371.4,379c-11.8-2.8-50.1-4.5-60.2,13c0,0-3.1-2.5,0.4-8c8.5-13.6,53.1-12.5,61.3-9.1
			C374.4,375.5,372.5,379.2,371.4,379z"
          />
          <path
            fill={colour6}
            d="M316.4,397.8c0,0,2.8,16.9,24.6,18.4c16.7,1.1,28.1-10.3,31.4-19c0,0-16.9,9.1-34,6.3
			C321.2,400.7,316.4,397.8,316.4,397.8z"
          />
          <path
            fill={colour0}
            d="M387.2,392.9c-13.6,2.4-27,20.5-51.7,15.3c-24.7-5.2-18.6-10.3-38.3-9.2c0,0,12.6-6.8,20.9-3.7
			c8.2,3.1,21.1,10.2,34,7.9C362.4,401.4,375.5,391.3,387.2,392.9z"
          />
          <path
            fill={colour0}
            d="M300.8,378.2c0,0,8.2,7.6,14.6,7l-2.6,2.3C312.7,387.6,304.1,386.1,300.8,378.2z"
          />
          <path
            fill={colour0}
            d="M306.3,373.2c0,0,6.1,9.5,12.4,10.6l-3.1,1.6C315.6,385.4,307.6,381.7,306.3,373.2z"
          />
          <path
            fill={colour0}
            d="M311.3,370c0,0,5.3,10,11.6,11.5l-3.2,1.3C319.6,382.9,312,378.5,311.3,370z"
          />
          <path
            fill={colour0}
            d="M318,367.1c0,0,4.5,10.4,10.6,12.5l-3.3,1C325.3,380.6,318,375.7,318,367.1z"
          />
          <path
            fill={colour0}
            d="M325.8,364.7c0,0,0.9,9.2,5.7,10.8l-3.3,1.1C328.2,376.6,323.2,372.4,325.8,364.7z"
          />
          <path
            fill={colour0}
            d="M387.2,392.9c-10.1-3.1-6.6-17.5-14.9-18.1l-14.4,1.7c0,0,13.2,0.6,16.1,4.3c2.8,3.7,4.8,12,11.6,12.3
			C392.4,393.4,391.9,394.3,387.2,392.9z"
          />
        </g>
      </g>
    </>
  );
};

export default Eyes_7;
